import React from 'react';
import { Flex } from '@mantine/core';
import { GetKYCInvestorInstanceRes } from '@dealstack/shared/lib/generated';
import { Step } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { StepTab } from '@dealstack/frontend/shared/components/StepTab/StepTab';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { StepStatusIndicator } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepTabs/StepStatusIndicator';

interface Props {
	currentStep: Step | null;
	steps: Step[];
	moveToStep: (step: number) => void;
	currentInvestor?: GetKYCInvestorInstanceRes;
	mipId?: string;
}

export const StepTabs = ({ currentStep, steps, moveToStep, currentInvestor, mipId }: Props) => {
	return (
		<Flex direction="row" display="flex" justify="space-between" align="center">
			{steps.map((step, index) => (
				<React.Fragment key={`${step.type}-${index}`}>
					<StepTab
						header={step.title}
						subHeader={step.description}
						isActive={currentStep?.type === step.type}
						onClick={() => moveToStep(index)}
						statusNode={
							<StepStatusIndicator
								step={step}
								currentInvestor={currentInvestor}
								mipId={mipId}
							/>
						}
					/>
					{index < steps.length - 1 && (
						<Icon variant="arrow-right-v3" style={{ opacity: 0.5 }} />
					)}
				</React.Fragment>
			))}
		</Flex>
	);
};
